import { Component, inject, OnInit, signal } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { MmhMeta, MmhService } from "@viewer/core/mmh/mmh.service";

@Component({
  standalone: true,
  selector: "o-mmh",
  templateUrl: "./mmh.component.html",
  styleUrls: ["./mmh.component.scss"],
  imports: [TranslatePipe]
})
export class MmhComponent implements OnInit {
  public mmhMeta: MmhMeta;
  public shouldDisplay = signal(false);

  private mmhService = inject(MmhService);

  ngOnInit() {
    /**
     * Initialises the component by retrieving the metadata from the MMH.
     * If at least one of those differs from ‘-’, it must be displayed.
     */
    this.mmhService.getMMHInfo().then(mmhMeta => {
      this.mmhMeta = mmhMeta;
      this.shouldDisplay.set(
        [this.mmhMeta.leanMmh, this.mmhMeta.minNbTech, this.mmhMeta.techQualif].some(
          meta => meta !== "-"
        )
      );
    });
  }
}
